import { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
//image
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/Card';
import { getToken } from '../../../utils/auth';
import SavePostCardBody from './SavePostCardBody';
import SaveLostPostCardBody from './SaveLostPostCardBody';
import { useTranslation } from 'react-i18next';


const SavePostCard = ({ post, handleAllPost, lostPost, handleAllLostPost }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<Col lg={12} className="row m-0 p-0">
                {
                    post?.length === 0 && lostPost?.length === 0 &&
                    <p style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>{t('noPostSaved')}</p>
                }

                {post && post.length > 0 && (
                    post.map((data, index) => (
                        <Col sm={12} key={index}>
                            <Card className=" card-block card-stretch card-height">
                                <SavePostCardBody data={data} index={index} handleAllPost={handleAllPost} />
                            </Card>
                        </Col>
                    ))
                )}
                {lostPost && lostPost.length > 0 && (
                    lostPost.map((data, index) => (
                        <Col sm={12} key={index}>
                            <Card className=" card-block card-stretch card-height">
                                <SaveLostPostCardBody data={data} index={index} handleAllLostPost={handleAllLostPost} />
                            </Card>
                        </Col>
                    ))
                )}

            </Col>
        </>
    )
}

export default SavePostCard
